var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports", "jquery", "./context", "./priceFormula"], function (require, exports, $, context_1, priceFormula_1) {
    "use strict";
    exports.__esModule = true;
    function createImg(href) {
        return $('<img/>').attr('src', href);
    }
    function createLink(href) {
        return $('<a/>').attr('href', href);
    }
    function prependRenderedImage($thumbs, renderedImages) {
        insertThumbImage($thumbs, renderedImages, false);
    }
    function insertThumbImage($thumbs, renderedImages, appending) {
        var $first = $('<div class="a-left"></div>');
        var fullImage = renderedImages.full;
        var detailImage = renderedImages.detail;
        var thumbImage = renderedImages.thumb;
        $first.append(createLink(fullImage).attr({
            'class': 'cloud-zoom-gallery',
            'rel': "useZoom: 'zoom1', smallImage: '" + detailImage + "'"
        }).append(createImg(thumbImage)));
        $first.append(createLink(fullImage).attr({ 'data-gallery': 'lightbox-pd', 'class': 'img-zoom' }));
        if (appending) {
            $thumbs.append($first);
        }
        else {
            $thumbs.prepend($first);
        }
        var defaultPicture = $('.defaultPicture.customize-form-main');
        if (!defaultPicture.find('a.cloud-zoom').attr('href')) {
            defaultPicture.find('a.cloud-zoom').attr('href', renderedImages.full);
            defaultPicture.find('img').attr('src', renderedImages.detail);
        }
        return $first;
    }
    exports.insertThumbImage = insertThumbImage;
    function replaceThumbImage($existing, images) {
        if (images.full) {
            var galleryLink = $existing.find('.cloud-zoom-gallery');
            galleryLink.attr({
                href: images.full,
                rel: "useZoom:'zoom1', smallImage:'" + images.detail + "'"
            }).data('relOpts').smallImage = images.detail;
            $existing.find('.img-zoom').attr('href', images.full);
        }
        if (images.thumb) {
            $existing.find('img').attr('src', images.thumb);
        }
    }
    exports.replaceThumbImage = replaceThumbImage;
    function syncFirstCover($thumbs, renderedImages) {
        var $cover = $('.defaultPicture a.cloud-zoom').first();
        $cover.attr('href', renderedImages.full);
        $cover.find('img').first().attr('src', renderedImages.detail);
    }
    var slimBoxAnchor = function (all) { return all ? $('.product-details-info .defaultPicture, .product-details-info .defaultPreview') : $('.product-details-info .defaultPicture:visible, .product-details-info .defaultPreview:visible'); };
    exports.slimBoxClicker = function () { return slimBoxAnchor(true); };
    function buildSlimboxLinks() {
        var links = $('.product-thumbs > div[style=""] a[data-gallery="lightbox-pd"][href!=""]')
            .add('.product-thumbs > div:not([style]) a[data-gallery="lightbox-pd"][href!=""]');
        var previews = $('#desktopPreview a[data-gallery]');
        if (!priceFormula_1.attributesMatchProductPicture()) {
            links = links.add(previews);
        }
        var hrefs = $.unique($.map(links, function (x, i) { return $(x).attr('href'); }));
        var hash = {};
        $.each(hrefs, function (i, k) { hash[k] = true; });
        links = links.filter(function (i, link) {
            var href = $(link).attr('href');
            if (hash[href]) {
                delete hash[href];
                return true;
            }
            return false;
        });
        return links;
    }
    exports.buildSlimboxLinks = buildSlimboxLinks;
    function fillFabricPicturesForStyleZoomViewer(fabricSpec, base) {
        if (fabricSpec) {
            var fabricDetailsImages = fabricSpec.details;
            var fabricThumbImages = fabricSpec.thumbs;
            var fabricFullImages = fabricSpec.fullImages;
            var appending = fabricSpec.appending;
            var i = 0;
            var index = base || 0;
            var hasFabricImageElements = $('#fabricImage0').length > 0;
            if (hasFabricImageElements) {
                for (i = 0; i < fabricThumbImages.length; i++) {
                    $("#fabricImage" + index).attr('rel', "useZoom: 'zoom1', smallImage: '" + fabricDetailsImages[i] + "'");
                    $("#fabricThumbImage" + index).attr('src', fabricThumbImages[i]);
                    $("#fabricImage" + index).attr('href', fabricFullImages[i]);
                    $("#fabricLightbox" + index).attr('href', fabricFullImages[i]);
                    $("#fabricLightbox" + index).attr('enabled', 'true');
                    $("#fabricPicture" + index).attr('style', '');
                    if (index == 0) {
                        $('#zoom1').attr('href', fabricFullImages[0]);
                        $('#zoom1image').attr('src', fabricDetailsImages[0]);
                    }
                    index++;
                }
                for (; index < 10; index++) {
                    $('#fabricPicture' + index).hide();
                }
            }
            else {
                showExtraImageForCustomization($('#desktopPreview'), __assign({}, fabricSpec, { id: fabricSpec.attributeName || 'fabric' }));
            }
            $('.picturethumbs .productPicture').hide();
            $('.product-thumbs').trigger('rezoom', 0);
            $("a[data-gallery^='lightbox']").unbind('click');
            exports.slimBoxClicker().slimbox({
                links: buildSlimboxLinks(),
                loop: true,
                nextKeys: [39, 78, 32]
            }, null, function (x) { return true; });
        }
    }
    function watchProductThumbs() {
        $('.product-thumbs').on('rezoom', function (e, index) {
            $('.product-thumbs .cloud-zoom-gallery').CloudZoom();
            setTimeout(function () {
                if ($("#picturePreview").is(':visible')) {
                    var thumbs = $('.product-thumbs > div');
                    $(thumbs[Math.min(index, thumbs.length - 1)]).find('.cloud-zoom-gallery').click();
                }
            }, 100);
        });
    }
    exports.watchProductThumbs = watchProductThumbs;
    function fillFabricPicturesForStyleTouchSlider(fabricSpec, base) {
        var appending = fabricSpec.appending;
        if (fabricSpec) {
            var images = fabricSpec.details;
            var fullImages = fabricSpec.fullImages;
            var $slides = $('.photoshow .image-viewport');
            var i = 0;
            if (!$slides.length) {
                fillFabricPicturesForStyleZoomViewer(fabricSpec, base);
                return;
            }
            var dotsAdded = images.length;
            var liveViewPrompt = $slides.find('>.liveview-prompt');
            if (!appending) {
                $slides.find(">:not(.canvasDiv, .liveview-prompt)").remove();
                dotsAdded = images.length + $slides.children().length;
            }
            for (i = 0; i < images.length; i++) {
                var image = images[i];
                var divHtml = "<div><img src=\"" + image + "\" data-full-image=\"" + fullImages[i] + "\"/></div";
                if (liveViewPrompt.length) {
                    $(divHtml).insertBefore(liveViewPrompt);
                }
                else {
                    $slides.append($(divHtml));
                }
            }
            var $paging = $('.photoshow .paging');
            $paging.data('total', appending ? parseInt($paging.data('total')) + dotsAdded : dotsAdded);
            var $cur = $slides.find('.canvasDiv.current');
            if ($cur.length === 0) {
                $slides.touchSlider('current', 0);
            }
        }
    }
    function fillFabricPicturesForStyle(fabricSpec, base) {
        if (context_1["default"].isMobile()) {
            fillFabricPicturesForStyleTouchSlider(fabricSpec, base);
        }
        else {
            fillFabricPicturesForStyleZoomViewer(fabricSpec, base);
        }
    }
    exports.fillFabricPicturesForStyle = fillFabricPicturesForStyle;
    var extraImagePrefixes = ['thumb', 'lightbox'];
    function removeExtraImageForCustomization($container, id) {
        $.map(extraImagePrefixes, function (prefix) { return $container.find("#" + prefix + "_" + id).remove(); });
    }
    exports.removeExtraImageForCustomization = removeExtraImageForCustomization;
    var renderThumb = function (thumb, detail, full) {
        return $("<a class='cloud-zoom-gallery'><img src='" + thumb + "'/></a>").attr({
            rel: "useZoom: '" + $('.defaultPicture a.cloud-zoom').attr('id') + "', smallImage: '" + detail + "'",
            href: full
        });
    };
    var renderLightBox = function (full) { return $("<a href='" + full + "' data-gallery='lightbox-pd'/>"); };
    var insertOrUpdateElement = function ($container, $after, id, $thumb) {
        var $existing = $container.find("#" + id);
        if ($existing.length) {
            $existing.replaceWith($thumb.attr('id', id));
        }
        else {
            $thumb.attr('id', id).insertAfter($after);
        }
        return $thumb;
    };
    function showExtraImageForCustomization($container, imageSpec) {
        var id = imageSpec.id, thumb = imageSpec.thumbs[0], detail = imageSpec.details[0], full = imageSpec.fullImages[0];
        return $.map(extraImagePrefixes, function (prefix) {
            switch (prefix) {
                case 'thumb': {
                    var $thumb = insertOrUpdateElement($container, $container.find('>.hidden').prev(), prefix + "_" + id, renderThumb(thumb, detail, full));
                    $thumb.CloudZoom();
                    $thumb.on('click', function () {
                        $('.defaultPicture').show();
                        $('.defaultPreview').hide();
                    });
                    return $thumb;
                }
                case 'lightbox':
                    return insertOrUpdateElement($container, $container.find('>.hidden > a:last-child'), prefix + "_" + id, renderLightBox(full));
                default:
                    return null;
            }
        });
    }
    exports.showExtraImageForCustomization = showExtraImageForCustomization;
    function onAttributeChange($container, $list, e) {
        var $input = $(e.currentTarget);
        var attributeName = $input.data('attribute-name');
        var $selectedImg = $list.find('.selected img');
        var thumb = $selectedImg.attr('src');
        var details = $selectedImg.data('details');
        var full = $selectedImg.data('full');
        if (!thumb) {
            removeExtraImageForCustomization($container, attributeName);
        }
        else {
            showExtraImageForCustomization($container, {
                id: attributeName,
                details: [details],
                thumbs: [thumb],
                fullImages: [full],
                previewAvailable: true,
                appending: 0
            });
        }
    }
    exports.onAttributeChange = onAttributeChange;
    function updateProductSizeInfo($container, size) {
        var $info = $container.find('.product-size-info');
        var showSize = function (dimension, size) { return (size === undefined) ? '' : size + "\" " + dimension + " "; };
        var $size = $info.find('label:last-child');
        if (size.width && size.height) {
            $size.text(showSize('W', size.width) + " x " + showSize('L', size.height));
        }
        else if (size.width) {
            $size.text(showSize('W', size.width));
        }
        else if (size.height) {
            $size.text(showSize('L', size.height));
        }
        else {
            $size.text('');
        }
    }
    exports.updateProductSizeInfo = updateProductSizeInfo;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/productImages.js
// module id = 32
// module chunks = 0